import type {
    AxiosError, AxiosRequestConfig, AxiosResponse,
} from 'axios';
import { AuthenticationRoutes } from '@/services/routes/AuthenticationRoutes';
import AbstractMiddleware from '@/services/middleware/AbstractMiddleware';
import type { AxiosErrorMiddleware } from '@/services/middleware/AxiosMiddleware';
import { notifyAndHandleNoAccess } from '@/functions/routeHelpers';
import router from '@/router';

/* eslint-disable class-methods-use-this */
class AccessDeniedMiddleware extends AbstractMiddleware implements AxiosErrorMiddleware {
    public canHandleError = (error: AxiosError): boolean => {
        const status = error.response?.status;
        return status === 403;
    };

    /* eslint-disable-next-line consistent-return */
    public onError = async (error: AxiosError): Promise<AxiosResponse|undefined> => {
        const previousRequest: AxiosRequestConfig|undefined = error.config;

        if (
            previousRequest?.url !== AuthenticationRoutes.LOGIN
            && previousRequest?.url !== AuthenticationRoutes.REFRESH
        ) {
            const route = await notifyAndHandleNoAccess();
            router.push(route);
            return Promise.resolve(undefined);
        }

        /**
         * Reject the promise to allow the error to propagate,
         * allowing the error to be caught by the calling function
         * and the restricted access page to be shown.
         */
        return Promise.reject(error);
    };
}

export { AccessDeniedMiddleware };
